export default {
  meta: {
    title: '门店管理', // 拓店标准版-门店管理
    url: '/expandstore/shop' // 埋点用，记录所属模块
  },
};
